module.exports = __webpack_public_path__ + "348b47e89d165454096715badd43d5c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/national-state-parks/NiagaraFalls2.jpg
// module id = 3537
// module chunks = 0